module.exports = __webpack_public_path__ + "static/media/welshons.5b06599c.jpg";